export interface Challan {
  id: string;
  violation: string;
  amount: number; // INR, shown as ₹
  status: 'Unpaid' | 'Paid';
  dueDate: string; // human-readable, e.g. "05 Aug 2026"
  paidOn?: string; // optional, e.g. "10 Jul 2026"
}

export const selectedVehicle = 'MH01AB1234';

export const challans: Challan[] = [
  {
    id: 'CHL-001',
    violation: 'Overspeeding',
    amount: 1500,
    status: 'Unpaid',
    dueDate: '15 Aug 2026',
  },
  {
    id: 'CHL-002',
    violation: 'Red light violation',
    amount: 1000,
    status: 'Paid',
    dueDate: '',
    paidOn: '10 Jul 2026',
  },
  {
    id: 'CHL-003',
    violation: 'No parking',
    amount: 500,
    status: 'Unpaid',
    dueDate: '05 Aug 2026',
  },
];

export type Intent = 'amount' | 'status' | 'payment' | 'dueDate' | 'help';

export interface AssistantConfig {
  name: string;
  subtitle: string;
  avatar: 'bot';
}

export const assistantConfig: AssistantConfig = {
  name: 'Park+ Assist',
  subtitle: 'Ask about your challans',
  avatar: 'bot',
};

export interface QuickReply {
  label: string;
  intent: Intent;
}

export const quickReplies: QuickReply[] = [
  { label: 'Total amount due', intent: 'amount' },
  { label: 'Is my challan paid?', intent: 'status' },
  { label: 'How do I pay?', intent: 'payment' },
  { label: 'When is the due date?', intent: 'dueDate' },
];

export function formatCurrency(amount: number): string {
  return `₹${amount.toLocaleString('en-IN')}`;
}
